export default __webpack_public_path__ + "static/media/portfolio-email.526e2a76.png";